import type { AddShopMemberWithTokenDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export default function useAddShopMemberWithToken({
	onSuccess,
}: {
	onSuccess?: (data: unknown, variables: { shopId: string }) => void;
}) {
	return useApiMutation("post", "/public/shops/{shopId}/members/token", {
		notify: false,
		onSuccess: onSuccess as ((data: unknown) => void) | undefined,
		mapVariables: ({
			shopId,
			data,
		}: {
			shopId: string;
			data: AddShopMemberWithTokenDto;
		}) => ({
			params: { path: { shopId } },
			body: data,
		}),
	});
}
